const toUrlEncoded = (obj) =>
  Object.keys(obj)
    .map((k) => `${encodeURIComponent(k)  }=${  encodeURIComponent(obj[k])}`)
    .join('&');
const fpPromise = import('@/assets/js/fp-v3.js').then((FingerprintJS) => FingerprintJS.load());

function uuid(len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
    let i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}
export const getAppEnv = async () => {
  const skey = 'App-Env';
  let appEnv = window.localStorage.getItem(skey);
  // console.log(appEnv);
  if (appEnv == null || appEnv === '') {
    await fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        const visitorId = result.visitorId;
        const params = {
          platform: 'PC',
          deviceid: `${uuid(8, 16)  }_${  visitorId}`,
          appVersion: 'v1.1.0',
        };
        appEnv = encodeURIComponent(toUrlEncoded(params));
        window.localStorage.setItem(skey, appEnv);
      });
    // console.log('获取',appEnv);
  }
  return appEnv;
};

export const logout = ()=>{
  setTimeout(() => {
    window.location.href='/login'
    localStorage.clear();
  }, 2500);
}

export const asyncToSync = (fun,delay = 1000)=>{
  return new Promise(res =>{
    setTimeout(()=>{
      fun()
      res()
    },delay)
  })
}

